"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnAdded_SwarmRandomEnemyEventHandlerScript = void 0;
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Random_1 = require("../../utils/Random");
let OnAdded_SwarmRandomEnemyEventHandlerScript = class OnAdded_SwarmRandomEnemyEventHandlerScript {
    run(sequence, container, handler, event) {
        const canSwarm = container.selectLivingTargets(event.subject, Target_1.Target.AllEnemies);
        const targetId = (0, Random_1.randomElement)(canSwarm);
        container.applyDebuff({
            sequence,
            attackerId: event.subject,
            duration: Duration_1.Duration.Permanent,
            targetId,
            effect: new core_1.SwarmedEffectArgs(),
        });
    }
};
OnAdded_SwarmRandomEnemyEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("OnAdded_SwarmRandomEnemy")
], OnAdded_SwarmRandomEnemyEventHandlerScript);
exports.OnAdded_SwarmRandomEnemyEventHandlerScript = OnAdded_SwarmRandomEnemyEventHandlerScript;
